'use strict';

/* Стили */
import '../css/site.scss';

/* Библиотеки */
import { initAccordion } from './modules/accordion/init-accordion.js';

/* Скрипты */
import sliders from './modules/sliders.js/sliders';
import faq from './modules/faq.js';
import collapse from './modules/collapse.js';
import initBanner from './modules/init-banner.js';
import site from './modules/site.js';
import form from './modules/form/form.js';
import metrics from './modules/metrics.js';
import UtmTags from './modules/UtmTags.js';
import initTooltips from './modules/init-tooltips.js';
import renderStepsModal from './modules/modal/render-steps-modal.js';
import initTabs from './modules/init-tabs.js';
import initChangeDate from './modules/date/index.js';
import initWidjet from './modules/init-widget.js';
import initMoreButton from './modules/init-more-button.js';
import { initTab } from './modules/tabs/init-tabs.js';
import '../lib/ls.video-vk-rutube-embed';
import initFilters from './modules/init-filters.js';
import initCookies from './modules/init-cookies.js';
import { initModals } from './modules/modal/init-modals.js';
import changeLinkBot from './modules/changeLinkBot.js';
import clearDublicateUtm from './modules/clearDublicateUtm.js';

document.addEventListener('DOMContentLoaded', () => {
    clearDublicateUtm();
    initModals();
    initTab();
    initChangeDate();
    UtmTags();
    metrics();
    changeLinkBot();
    initBanner();
    initFilters();
    collapse();
    initAccordion();
    initTooltips();
    site();
    faq();
    sliders();
    form();
    renderStepsModal();
    initTabs();
    initWidjet();
    initCookies();

    // Comments
    if (window.innerWidth <= 750) {
        initMoreButton();
    }

    console.log('Test');
});
